import { render, staticRenderFns } from "./EditCandidateForm.vue?vue&type=template&id=46975a90&"
import script from "./EditCandidateForm.vue?vue&type=script&lang=js&"
export * from "./EditCandidateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports